import { useState } from "react";
import Input from '@/components/Input';
import Button from '@/components/Button';
import axios from "axios";
import LanguageIcon from '@mui/icons-material/Language';
import { checkPasswordConditions, getErrorMessage } from '@/utils/Errors';

export default function Recover({t,language,apiUrl,sendMessage,setIsForgot,setShowLanguage}){

	const [data, setData] = useState({
        password: null,
        password2: null
    });

    const changeLanguage = () => {
        setShowLanguage(true);
    };

	const [ recoverToken ] = useState(new URL(location.href).searchParams.get('token'));
    const [ recoverEmail ] = useState(new URL(location.href).searchParams.get('email'));

	const handleInput = (e) => {

        var name = e.target.name;
        var value = e.target.value;

        if(name === 'password'){
        	setData({password:value,password2:data?.password2});
        }
        else{
        	setData({password:data?.password,password2:value});
        }
    };

    // submit with enter
    const handleKeyDown = (e) => {
		if (event.key === 'Enter') {
			handleSubmit(e);
		}
	}

	const handleBack = () => {
		const url = '/';
		window.history.pushState({path:url},'',url);
		setIsForgot(false)
	}

	// forgot password
	const handleSubmit = () => {

		const password = data?.password;
		const password2 = data?.password2;

		var error = false;
		if(!password || password.length === 0 || !password2 || password2.length === 0){
			error = true;
			sendMessage(t('password.errors.empty'),'error');
		}
		else{
			if(password !== password2){
				error = true;
				sendMessage(t('password.errors.notequal'),'error');
			}
			else{
				const errors = checkPasswordConditions(password);
				const keys = Object.keys(errors); 				
				if(keys && keys?.length > 0){
					error = true;
					const errorPassword = getErrorMessage(t,'password',errors);
					sendMessage(errorPassword,'error');
				}
			}
		}

		if(!error){
			
			const apiPath = '/recover';

	        const config = {
	            //headers: {} 
	        };

	        const send = {
	            language: language,	            
	            data: {	            	
	                email: recoverEmail,
	                token: recoverToken,
	                password: data.password,
	                password2: data.password2
	            }
	        };

            var errorMessage = t('login.recover.error');
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {
                    
                if(response?.data){
              
                    var responseData = response.data;

                    // if result is ok (1)                
                    if(responseData?.result){                      	
                        sendMessage(t('login.recover.passwordchanged'));
                        handleBack();
                    } 
                    else{

                        // check error message
                        if(responseData?.data?.reasons){      
                        	errorMessage = getErrorMessage(t,'password',responseData?.data?.reasons);
                        }
                        
                        sendMessage(errorMessage,'error');                        
                    }
                }
                else{
                    sendMessage(errorMessage,'error');   
                }
            })
            .catch(function (error){
            	if(error){
                	sendMessage(errorMessage,'error');                
                }
            });
		}
	}

 	return (
    	<div id='login-page'>
	        
	        <div id='login-box'>

	        	<div className='text-end pt-1 pe-1'>
			        <Button 
			        	sx={{padding:1,color:'white',border:0}} 
			        	onClick={changeLanguage}
	                	icon={<LanguageIcon/>}
	                />
	            </div>

		        <div className="text-center pt-16">
		         	<img
		            	alt="Vito"
		            	src="/images/logo.png"
		            	className="mx-auto"
		          	/>
		        </div>	

		        <div id="login-form">

		        	<div className='text-white text-center mb-8'>
		        		{t('login.recover.title')}
		        	</div>	  
		          
		          	<form className=''>
		            	
		            	<div>
		              		<div className="mt-2">             			
			                	<Input	     
				                	className='login-input'               
				                    name="password"
				                    type="text"
				                    value={data?.password}	                    
				                    placeholder={t('login.recover.password')}
				                    autoComplete="email"
				                    onChange={handleInput}
				                    error=''
				        			handleKeyDown={handleKeyDown}
				        			variant='filled'
			                	/>
		              		</div>
		            	</div>

		            	<div>
		              
		              		<div className="mt-6">		              			
		                		<Input	             
				                	className='login-input'       
				                    name="password2"
				                    type="text"
				                    value={data?.password2}	                    
				                    placeholder={t('login.recover.password2')}
				                    autoComplete="password"
				                    onChange={handleInput}
				                    error=''
				        			handleKeyDown={handleKeyDown}
				        			variant='filled'
		                		/>			                	
		              		</div>		              		

		            	</div>

		            	<div className='flex justify-center mt-8'>
		            		
		            		<div className=''>
			              		<Button
			                		type="back"
			                		text={t("actions.back.title")}
			                		onClick={() => handleBack()}
			              		/>			              	
			            	</div>

			            	<div className='ml-2'>		            		
			              		<Button
			                		type="login"
			                		text={t("login.recover.button")}
			                		onClick={handleSubmit}
			              		/>			              	
			            	</div>
			            </div>

		          	</form>

		        </div>
	      	</div>
    	</div>
  )
}
